import {connect} from 'react-redux'
import {compose} from 'redux'
import ParametersPage from '../components/parameters-page'
import { setSubmitError } from "../actions/survey"
import {getVariables} from '../utilities/route'
import {withData} from '../decorators/with-data'
import gql from 'graphql-tag'
import { graphql } from 'react-apollo'
import {withTranslations} from '../decorators/with-translations'
import {QUESTIONNAIRE_FRAGMENT} from "../graphql/fragments";

const query = gql`
  query ParametersPage($languageCode: String) {
    questionnaire(languageCode: $languageCode) {
      ...QuestionnaireFragment
    }
  }
  ${QUESTIONNAIRE_FRAGMENT}
`;

const chooseRespondentParameterOptions = gql`
  mutation ChooseRespondentParameterOptions($parameterOptionIds: [UUID!]!) {
    chooseRespondentParameterOptions(
      parameterOptionIds: $parameterOptionIds
    )
  }
`

const consent = gql`
  mutation ConsentQuestionnairePolicy($id: UUID!, $consent: Boolean!, $languageCode: String) {
    consentQuestionnairePolicy(id: $id, consent: $consent, languageCode: $languageCode) {
      ...QuestionnaireFragment
    }
  }
  ${QUESTIONNAIRE_FRAGMENT}
`;

const goToQuestions = gql`
  mutation GoToQuestions($languageCode: String) {
    goToQuestions(languageCode: $languageCode) {
      ...QuestionnaireFragment
    }
  }
  ${QUESTIONNAIRE_FRAGMENT}
`;

const mapStateToProps = (
  { survey: { submitError } }
) => {
  return {
    submitError,
  }
}

const mapDispatchToProps = (dispatch, props) => {
  return {
    onSubmitError: (error) => {
      dispatch(setSubmitError(error))
    },
  }
}

export default compose(
  withTranslations,
  withData(query, { forceFetch: false, options: getVariables }),
  connect(mapStateToProps, mapDispatchToProps),
  graphql(chooseRespondentParameterOptions, { name: "chooseRespondentParameterOptions" }),
  graphql(consent, { name: "changeConsent" }),
  graphql(goToQuestions, { name: "goToQuestions" })
)(ParametersPage);



// WEBPACK FOOTER //
// ./src/containers/parameters-page.js